import { isConfigEnabled, INVENTORY_QTY_SHOW_SUPPLIER_PARAM } from '../api/sys/param'

/** 库存是否按供应商展示（inventory-qty-show-supplier=1 时显示供应商列/筛选） */
export default {
  data() {
    return {
      inventoryQtyShowSupplier: false
    }
  },
  methods: {
    loadInventoryQtyShowSupplierPolicy() {
      return isConfigEnabled(INVENTORY_QTY_SHOW_SUPPLIER_PARAM).then(enabled => {
        this.inventoryQtyShowSupplier = enabled
        return enabled
      })
    }
  }
}
